import { CSRF_HEADER } from "@esi/shared";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api.ts";
import { ok } from "../api-errors.ts";

export const accountKeys = {
  all: ["account"] as const,
  account: ["account", "self"] as const,
  sessions: ["account", "sessions"] as const,
  connectedApps: ["account", "connected-apps"] as const,
  mcp: ["account", "mcp"] as const,
};

export function useAccount() {
  return useQuery({
    queryKey: accountKeys.account,
    queryFn: async () => ok(await api.api.account.$get()),
  });
}

export function useAccountSessions() {
  return useQuery({
    queryKey: accountKeys.sessions,
    queryFn: async () => ok(await api.api.account.sessions.$get()),
  });
}

/** Request options of an account mutation: the session's CSRF token. */
export const csrf = (csrfToken: string) => ({ headers: { [CSRF_HEADER]: csrfToken } });

/**
 * `csrf` with a JSON body, for a route that reads an optional body it does not declare to the
 * typed client (a dismissal's `{ reason }`, recommendation-outcomes): sent as the request's init.
 */
export const csrfJson = (csrfToken: string, body: unknown) => ({
  init: {
    headers: { [CSRF_HEADER]: csrfToken, "content-type": "application/json" },
    body: JSON.stringify(body),
  },
});

/** Throws the response's `ApiError` unless it succeeded (no body expected). */
export { needsReauth, noContent as done } from "../api-errors.ts";
